import AddressInfoModel from "./address-info";
import CreditCardInfoModel from "./credit-card-info";

export default class GatewaySubscriptionDetailsPaypalModel {

    constructor(model) {
        if (!model) {
            model = {};
        }

        // TODO: Add paypal fields

        this.credit_card_info = new CreditCardInfoModel(model.credit_card_info);
        this.billing_info = new AddressInfoModel(model.billing_info);
        this.shipping_info = new AddressInfoModel(model.shipping_info);
    }

}
